import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const useScrollAnimations = () => {
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile =
      window.matchMedia('(pointer: coarse)').matches ||
      window.matchMedia('(max-width: 768px)').matches;

    const ctx = gsap.context(() => {
      // No mobile: conteúdo visível de imediato (melhor LCP/TBT em 4G)
      if (prefersReducedMotion || isMobile) {
        gsap.set('.gsap-reveal, .gsap-reveal-left, .gsap-reveal-right', {
          opacity: 1,
          x: 0,
          y: 0,
          clearProps: 'transform',
        });
        return;
      }

      gsap.utils.toArray('.gsap-reveal').forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, y: 28 },
          {
            opacity: 1,
            y: 0,
            duration: 0.4,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 92%',
              once: true,
              toggleActions: 'play none none none',
            },
          }
        );
      });

      gsap.utils.toArray('.gsap-reveal-left').forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, x: -36 },
          {
            opacity: 1,
            x: 0,
            duration: 0.4,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 92%',
              once: true,
              toggleActions: 'play none none none',
            },
          }
        );
      });

      gsap.utils.toArray('.gsap-reveal-right').forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, x: 36 },
          {
            opacity: 1,
            x: 0,
            duration: 0.4,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 92%',
              once: true,
              toggleActions: 'play none none none',
            },
          }
        );
      });

      gsap.utils.toArray('.gsap-parallax').forEach((el) => {
        gsap.to(el, {
          yPercent: -10,
          ease: 'none',
          scrollTrigger: {
            trigger: el.parentElement || el,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        });
      });
    });

    const refresh = () => ScrollTrigger.refresh();
    const refreshTimer = window.setTimeout(refresh, 150);
    window.addEventListener('load', refresh);
    window.addEventListener('resize', refresh);

    return () => {
      window.clearTimeout(refreshTimer);
      window.removeEventListener('load', refresh);
      window.removeEventListener('resize', refresh);
      ctx.revert();
    };
  }, []);
};
